"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultHosts = void 0;
exports.defaultHosts = {
    aiGateway: 'https://ai-gateway.abtasty.com',
    default: 'https://api.abtasty.com',
    dataExplorer: 'https://api-data-explorer.abtasty.com',
    realtime: 'https://api-realtime.abtasty.com',
    exporter: 'https://uc-exporter.abtasty.com',
    moneyBack: 'https://api-roi.abtasty.com',
    reporting: 'https://api-reporting.abtasty.com',
    uvCounter: 'https://api-uv-counter.abtasty.com',
    assetsManager: 'https://api-assets-manager.abtasty.com',
    integrationDatabase: 'https://api-datawarehouse-integration.abtasty.com',
    flagship: 'https://api-flagship.abtasty.com',
    integration: 'https://integration-api.abtasty.com',
    liveHit: 'https://api-live-hit.abtasty.com',
};
//# sourceMappingURL=defaultHosts.js.map